import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import EditorContent from "./EditorContent";
export default class Editor extends React.Component {
  render() {
    let id = this.props.match.params.id;

    return (
      <div class="wrapper">
        
        <Navbar />
        <Mainmenu />
        <EditorContent id={id} />
        <Footer />
      </div>
    );
  }
}
